import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Typography,
} from "@mui/material";

const ModalPuestos = ({
  open,
  onClose,
  puestos = [],
  idCandidato,
  defaultValue,
  showToast,
}) => {
  const [selectedPuesto, setSelectedPuesto] = useState(defaultValue ?? "");

  useEffect(() => {
    setSelectedPuesto(defaultValue ?? "");
  }, [defaultValue]);
  //const UrlApi = "http://localhost:27021/api"; //usoLocal
  const UrlApi = "https://empleosback.netizar.com/api"; //Ruta para produccion

  const handleChange = (event) => {
    setSelectedPuesto(event.target.value);
  };

  const handleConfirm = async () => {
    if (selectedPuesto !== 0 && selectedPuesto) {
      const response = await fetch(`${UrlApi}/actualizarPuesto`, {
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idCandidato: idCandidato,
          idPuesto: selectedPuesto,
        }),
        method: "PUT",
      });

      if (response.ok) showToast("Se le asigno el puesto correctamente");
      else
        showToast("Ocurrio un error inesperado al asignar un puesto", "error");
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Asignar Puesto</DialogTitle>
      <DialogContent>
        {puestos.length > 0 ? (
          <RadioGroup
            value={selectedPuesto}
            onChange={handleChange}
            defaultValue={String(selectedPuesto ?? "")}
          >
            {puestos.map((puesto) => (
              <FormControlLabel
                key={puesto.id}
                value={puesto.id.toString()}
                control={<Radio />}
                label={puesto.puesto}
              />
            ))}
          </RadioGroup>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No hay puestos disponibles.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          disabled={!selectedPuesto}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalPuestos;
